import { ItemType } from "./ItemType";

export class TblUserData {
  id?: number;
  empId?: string;
  IsAuthorized?: boolean;
  AuthRequestId?: number;
  Message?: string;
  Type?: string;
  ExpirationDate?: string;
  CBExpirationDate?: string;
  WBExpirationDate?: string;
  IsFree?: boolean;
  IsYearlySubscribed?: boolean;
  IsMonthlySubscribed?: boolean;
  TopSubscriptionLine?: string;
  SecondSubscriptionLine?: string;
  ThirdSubscriptionLine?: string;
  EmailId?: string;
  Modified?: any;
  AppSettings?: AppSettings;
  IsPending?: boolean;
  PendingPaidDate?: string;
  constructor(id: string, modified) {
    this.empId = id;
    this.Modified = modified;
  }
}

export class AppSettings {
  amPmTime: number;
  cities: string;
  isHerbToLocal: boolean;
  isSyncEnabled: boolean;
  selectedCities: ItemType[] = [];
}
